
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 248 246","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Home","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Style-Guide---Homepage","transform":"translate(-180 -2007)"}},[_c('g',{attrs:{"id":"Group-29","transform":"translate(180 2007)"}},[_c('g',{attrs:{"id":"Rectangle-3"}},[_c('use',{attrs:{"fill":"#FFF","xlink:href":"#path-1"}}),_c('rect',{attrs:{"stroke":"#CBD6E2","stroke-width":"1.5","x":".75","y":".75","width":"246.5","height":"244.5"}})]),_c('g',{attrs:{"id":"--Marketing/Logos/Sprocket","transform":"translate(53 49)","fill":"#FF7A59"}},[_c('path',{attrs:{"d":"M103.799 106.777c-11.068 0-20.04-8.878-20.04-19.83 0-10.952 8.972-19.831 20.04-19.831 11.067 0 20.04 8.879 20.04 19.832 0 10.95-8.973 19.83-20.04 19.83m5.999-58.01v-17.64c4.653-2.176 7.912-6.834 7.912-12.24v-.407c0-7.462-6.168-13.566-13.708-13.566h-.41c-7.539 0-13.707 6.104-13.707 13.566v.407c0 5.406 3.26 10.066 7.912 12.241v17.64c-6.928 1.06-13.258 3.887-18.478 8.049L30.373 19.139c.323-1.227.55-2.49.552-3.819C30.933 6.871 24.022.011 15.481 0 6.943-.01.01 6.831 0 15.282c-.01 8.45 6.901 15.31 15.442 15.32 2.783.004 5.36-.778 7.617-2.05l48.146 37.066c-4.094 6.116-6.494 13.442-6.494 21.33 0 8.256 2.636 15.894 7.09 22.176l-14.64 14.49c-1.158-.345-2.358-.584-3.631-.584-7.017 0-12.706 5.628-12.706 12.572 0 6.945 5.69 12.574 12.706 12.574 7.018 0 12.706-5.629 12.706-12.574 0-1.256-.242-2.445-.59-3.59l14.482-14.333c6.575 4.964 14.762 7.948 23.67 7.948 21.588 0 39.086-17.318 39.086-38.68 0-19.338-14.356-35.315-33.086-38.178","id":"Marketing/Logos/Sprocket"}})])])])])])
          )
        }
      }
    